export default __webpack_public_path__ + "static/media/playVideoIcon.df46b422.svg";